import OstroDynamicContent from 'app/components/OstroDynamicContent';
import Popover from 'app/components/Popover';
import { Body } from 'app/components/Typography';
import PhoneIcon from 'app/components/icons/PhoneIcon';
import useFetchLiveChat from 'app/hooks/fetch/useFetchLiveChat';
import useIsMobile from 'app/hooks/useIsMobile';
import React from 'react';

interface LiveChatPhoneButtonProps {
  onClick?: () => void;
  component?: React.ElementType;
  href?: string;
}
const LiveChatPhoneButton = React.forwardRef<HTMLButtonElement, LiveChatPhoneButtonProps>(
  ({ onClick, component: Component = 'button', href }, ref) => {
    return (
      <Component
        href={href}
        ref={ref}
        onClick={onClick}
        data-testid="live-chat-phone-button"
        id="ostro-live-chat-call-button"
        className="w-[32px] flex items-center justify-center mr-2.5"
      >
        <span className="bg-option flex items-center justify-center rounded-full w-[27px] h-[27px]">
          <PhoneIcon />
        </span>
      </Component>
    );
  }
);
LiveChatPhoneButton.displayName = 'LiveChatPhoneButton';

export default function PhoneButton({ onClick }: { onClick?: () => void }) {
  const isMobile = useIsMobile();
  const { data: liveChat } = useFetchLiveChat();

  if (!liveChat?.nurses_are_online || !liveChat?.config?.phone_call_cta_enabled) {
    return null;
  }

  return (
    <>
      {!isMobile && (
        <Popover
          button={<LiveChatPhoneButton onClick={onClick} />}
          transform={{ top: -10 }}
          positions="bottom"
        >
          <div>
            <OstroDynamicContent
              className="[&_p]:mb-0 text-center"
              content={liveChat?.config?.phone_call_cta_text}
            />

            <Body
              component="a"
              className="mt-3 text-white bg-black rounded-full leading-[30px] w-full block text-center"
              href={`tel:${liveChat?.config?.phone_number}`}
            >
              <PhoneIcon className="text-white inline mr-2" />
              {liveChat?.config?.phone_number}
            </Body>
          </div>
        </Popover>
      )}
      {isMobile && (
        <LiveChatPhoneButton
          component="a"
          href={`tel:${liveChat?.config?.phone_number}`}
          onClick={onClick}
        />
      )}
    </>
  );
}
